/**
 * 统一存储管理工具
 * 提供类型安全、错误处理的 localStorage 封装
 */
import logger from './logger'

/**
 * 获取存储值
 * @param {string} key - 存储键
 * @param {any} defaultValue - 默认值
 * @returns {any} 存储的值或默认值
 */
export function getStorage(key, defaultValue = null) {
  try {
    const item = localStorage.getItem(key)
    if (item === null) {
      return defaultValue
    }
    // 尝试解析 JSON
    try {
      return JSON.parse(item)
    } catch {
      // 如果不是 JSON，直接返回字符串
      return item
    }
  } catch (error) {
    logger.error(`Failed to get storage key "${key}":`, error)
    return defaultValue
  }
}

/**
 * 设置存储值
 * @param {string} key - 存储键
 * @param {any} value - 要存储的值
 * @returns {boolean} 是否成功
 */
export function setStorage(key, value) {
  try {
    const serialized = typeof value === 'string' ? value : JSON.stringify(value)
    localStorage.setItem(key, serialized)
    return true
  } catch (error) {
    logger.error(`Failed to set storage key "${key}":`, error)
    return false
  }
}

/**
 * 删除存储值
 * @param {string} key - 存储键
 * @returns {boolean} 是否成功
 */
export function removeStorage(key) {
  try {
    localStorage.removeItem(key)
    return true
  } catch (error) {
    logger.error(`Failed to remove storage key "${key}":`, error)
    return false
  }
}

/**
 * 清空所有存储（谨慎使用）
 * @returns {boolean} 是否成功
 */
export function clearStorage() {
  try {
    localStorage.clear()
    return true
  } catch (error) {
    logger.error('Failed to clear storage:', error)
    return false
  }
}

/**
 * 检查存储键是否存在
 * @param {string} key - 存储键
 * @returns {boolean} 是否存在
 */
export function hasStorage(key) {
  return localStorage.getItem(key) !== null
}

/**
 * 存储工具对象（兼容旧代码）
 */
const Storage = {
  get: getStorage,
  set: setStorage,
  remove: removeStorage,
  clear: clearStorage,
  has: hasStorage
}

export default Storage
